import React from 'react';
import cn from 'classnames';

import CTA from 'react-scale/components/ui/cta';
import MeshGradient from 'react-scale/components/ui/webgl/mesh-gradient';

const Hero = ({ theme, title, subtitle, icon, cta, webgl }) => {
  const cleanWebgl = typeof webgl === 'boolean' ? webgl.style : webgl;

  return (
    <div>
      {webgl && theme === 'dark' && (
        <div className="absolute inset-0 z-0 bg-black pointer-events-none">
          <MeshGradient style={cleanWebgl} />
          <div className="absolute inset-0 w-full bg-gradient-to-b from-black" />
        </div>
      )}
      <div className="py-16 text-center lg:p-24">
        <div className="container relative">
          {icon ? (
            <img
              className={cn('mt-0 mx-auto w-auto mb-4 h-16 md:h-18')}
              src={icon.src}
              alt={icon.alt}
            />
          ) : null}
          <h1 className={cn(textTheme[theme], 'font-aeonik text-4xl mb-4')}>{title}</h1>
          <p className={cn(textTheme[theme], 'text-lg max-w-4xl mx-auto')}>{subtitle}</p>
          {cta && (
            <div className="flex justify-center mt-8">
              <CTA theme={theme} cta={cta} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const textTheme = {
  dark: 'text-white',
  light: 'text-black'
};

Hero.defaultProps = {
  theme: 'dark',
  cta: false,
  webgl: false
};

export default Hero;
